"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var CommonModels_1 = require("../CommonModels");
var Discount_1 = require("../Discount");
var BundleCartDiscountLine_1 = require("../Discount/BundleCartDiscountLine");
// response interface from GET /queues endpoint
var PaymentQueueStatus;
(function (PaymentQueueStatus) {
    PaymentQueueStatus["PENDING"] = "pending";
    PaymentQueueStatus["READY_FOR_PICKUP"] = "ready for pickup";
    PaymentQueueStatus["OUT_FOR_DELIVERY"] = "out for delivery";
    PaymentQueueStatus["READY_FOR_DELIVERY"] = "ready for delivery";
    PaymentQueueStatus["COMPLETED"] = "completed";
    PaymentQueueStatus["CANCELLED"] = "cancelled";
    PaymentQueueStatus["IN_PROGRESS"] = "in progress";
})(PaymentQueueStatus = exports.PaymentQueueStatus || (exports.PaymentQueueStatus = {}));
// Uber Eats only; null for every other source. Separate from `status`,
// which keeps tracking fulfilment.
var PaymentQueueAcceptanceStatus;
(function (PaymentQueueAcceptanceStatus) {
    PaymentQueueAcceptanceStatus["PENDING"] = "pending";
    PaymentQueueAcceptanceStatus["ACCEPTING"] = "accepting";
    PaymentQueueAcceptanceStatus["ACCEPTED"] = "accepted";
    PaymentQueueAcceptanceStatus["DENYING"] = "denying";
    PaymentQueueAcceptanceStatus["DENIED"] = "denied";
    PaymentQueueAcceptanceStatus["EXPIRED"] = "expired";
    PaymentQueueAcceptanceStatus["CANCELLED_BY_INTEGRATOR"] = "cancelled_by_integrator";
})(PaymentQueueAcceptanceStatus = exports.PaymentQueueAcceptanceStatus || (exports.PaymentQueueAcceptanceStatus = {}));
var PaymentQueueOrderType;
(function (PaymentQueueOrderType) {
    PaymentQueueOrderType["PICKUP"] = "pickup";
    PaymentQueueOrderType["DELIVERY"] = "delivery";
})(PaymentQueueOrderType = exports.PaymentQueueOrderType || (exports.PaymentQueueOrderType = {}));
// This class will be used to capture necessary data, stringified then send to /queue endpoint to create paymentQueue
var CreatePaymentQueue = /** @class */ (function () {
    function CreatePaymentQueue(json, meta) {
        this.userId = null;
        this.customerId = null;
        this.customerName = null;
        this.notes = null;
        this.paymentQueueNotes = null;
        this.paymentLines = [];
        this.validatedBy = null;
        this.validatedAt = null;
        this.locationId = json.locationId;
        this.notes = json.notes;
        this.paymentQueueNotes = json.paymentQueueNotes;
        this.userId = json.employeeId;
        this.offlinePaymentId = json.offlinePaymentId;
        this.paymentLines = __spread(json.paymentLines, json.cartDiscountLines).map(function (pl) { return new CreatePaymentQueueLine(pl); });
        if (json.customerWithHistory) {
            this.customerId = json.customerWithHistory.customer.id;
            this.customerName = json.customerWithHistory.customer.name;
        }
        if (json.customerName) {
            this.customerName = json.customerName;
        }
        if (meta) {
            this.validatedAt = meta.validatedAt || null;
            this.validatedBy = meta.validatedBy || null;
        }
    }
    return CreatePaymentQueue;
}());
exports.CreatePaymentQueue = CreatePaymentQueue;
var CreatePaymentQueueLine = /** @class */ (function () {
    function CreatePaymentQueueLine(json) {
        this.discountPrice = 0;
        this.discountPercentage = 0;
        this.discountMessage = null;
        this.bulkPricePerInventorySubtracted = null;
        this.barcode = null;
        this.sku = null;
        this.price = null;
        this.productId = json.networkTransferObject.productId;
        this.productName = json.networkTransferObject.productName;
        this.quantity = json.networkTransferObject.inventorySubtracted;
        this.discountId = json.networkTransferObject.discountId;
        this.discountPrice = json.networkTransferObject.discountPrice;
        this.discountPercentage = json.discountPercentage;
        this.discountMessage = json.networkTransferObject.discountMessage;
        this.bulkPricePerInventorySubtracted = (json instanceof Discount_1.CartDiscountLine || json instanceof BundleCartDiscountLine_1.BundleCartDiscountLine)
            ? 1
            : json.bulkPricePerInventorySubtracted;
        this.barcode = json.networkTransferObject.barcode;
        this.sku = json.networkTransferObject.sku;
        this.price = json.networkTransferObject.price;
        this.loyaltyCost = json.networkTransferObject.loyaltyCost;
        this.scannedBy = json.networkTransferObject.scannedBy;
        this.externalReward = json.networkTransferObject.externalReward;
    }
    return CreatePaymentQueueLine;
}());
exports.CreatePaymentQueueLine = CreatePaymentQueueLine;
var PaymentQueueSearchFilter = /** @class */ (function (_super) {
    __extends(PaymentQueueSearchFilter, _super);
    function PaymentQueueSearchFilter(json) {
        var _this = _super.call(this, json) || this;
        _this.searchQuery = json.searchQuery;
        _this.externalOrderId = json.externalOrderId;
        _this.customerName = json.customerName;
        _this.locationIds = json.locationIds;
        _this.status = json.status;
        _this.devices = json.devices;
        _this.startDate = json.startDate;
        _this.endDate = json.endDate;
        _this.orderType = json.orderType;
        _this.externalSourceId = json.externalSourceId;
        return _this;
    }
    PaymentQueueSearchFilter.prototype.setSearchQuery = function (searchQuery) {
        this.searchQuery = searchQuery;
    };
    PaymentQueueSearchFilter.prototype.toggleLocationId = function (locationId) {
        var locationIdSet = new Set(this.locationIds);
        if (locationIdSet.has(locationId)) {
            locationIdSet.delete(locationId);
        }
        else {
            locationIdSet.add(locationId);
        }
        this.setLocationIds(Array.from(locationIdSet));
    };
    PaymentQueueSearchFilter.prototype.setLocationIds = function (locationIds) {
        this.locationIds = locationIds;
    };
    PaymentQueueSearchFilter.prototype.toggleStatus = function (status) {
        if (!this.status.includes(status)) {
            this.status.push(status);
        }
        else {
            this.status = this.status.filter(function (val) { return val !== status; });
        }
    };
    PaymentQueueSearchFilter.prototype.setStatus = function (status) {
        this.status = status;
    };
    PaymentQueueSearchFilter.prototype.setOrderType = function (orderType) {
        this.orderType = orderType;
    };
    PaymentQueueSearchFilter.prototype.setExternalSourceId = function (externalSourceId) {
        this.externalSourceId = externalSourceId;
    };
    PaymentQueueSearchFilter.prototype.toggleDevices = function (deviceId) {
        if (!this.devices.includes(deviceId)) {
            this.devices.push(deviceId);
        }
        else {
            this.devices = this.devices.filter(function (id) { return id !== deviceId; });
        }
    };
    PaymentQueueSearchFilter.prototype.setOffset = function (offset) {
        this.offset = offset;
    };
    PaymentQueueSearchFilter.prototype.setLimit = function (limit) {
        this.limit = limit;
    };
    PaymentQueueSearchFilter.prototype.setStartDate = function (startDate) {
        this.startDate = startDate;
    };
    PaymentQueueSearchFilter.prototype.setEndDate = function (endDate) {
        this.endDate = endDate;
    };
    __decorate([
        mobx_1.observable
    ], PaymentQueueSearchFilter.prototype, "locationIds", void 0);
    __decorate([
        mobx_1.observable
    ], PaymentQueueSearchFilter.prototype, "status", void 0);
    __decorate([
        mobx_1.observable
    ], PaymentQueueSearchFilter.prototype, "devices", void 0);
    __decorate([
        mobx_1.observable
    ], PaymentQueueSearchFilter.prototype, "searchQuery", void 0);
    __decorate([
        mobx_1.observable
    ], PaymentQueueSearchFilter.prototype, "externalOrderId", void 0);
    __decorate([
        mobx_1.observable
    ], PaymentQueueSearchFilter.prototype, "customerName", void 0);
    __decorate([
        mobx_1.observable
    ], PaymentQueueSearchFilter.prototype, "startDate", void 0);
    __decorate([
        mobx_1.observable
    ], PaymentQueueSearchFilter.prototype, "endDate", void 0);
    __decorate([
        mobx_1.observable
    ], PaymentQueueSearchFilter.prototype, "orderType", void 0);
    __decorate([
        mobx_1.observable
    ], PaymentQueueSearchFilter.prototype, "externalSourceId", void 0);
    __decorate([
        mobx_1.action
    ], PaymentQueueSearchFilter.prototype, "setSearchQuery", null);
    __decorate([
        mobx_1.action
    ], PaymentQueueSearchFilter.prototype, "toggleLocationId", null);
    __decorate([
        mobx_1.action
    ], PaymentQueueSearchFilter.prototype, "setLocationIds", null);
    __decorate([
        mobx_1.action
    ], PaymentQueueSearchFilter.prototype, "toggleStatus", null);
    __decorate([
        mobx_1.action
    ], PaymentQueueSearchFilter.prototype, "setStatus", null);
    __decorate([
        mobx_1.action
    ], PaymentQueueSearchFilter.prototype, "setOrderType", null);
    __decorate([
        mobx_1.action
    ], PaymentQueueSearchFilter.prototype, "setExternalSourceId", null);
    __decorate([
        mobx_1.action
    ], PaymentQueueSearchFilter.prototype, "toggleDevices", null);
    __decorate([
        mobx_1.action
    ], PaymentQueueSearchFilter.prototype, "setOffset", null);
    __decorate([
        mobx_1.action
    ], PaymentQueueSearchFilter.prototype, "setLimit", null);
    __decorate([
        mobx_1.action
    ], PaymentQueueSearchFilter.prototype, "setStartDate", null);
    __decorate([
        mobx_1.action
    ], PaymentQueueSearchFilter.prototype, "setEndDate", null);
    return PaymentQueueSearchFilter;
}(CommonModels_1.Pagination));
exports.PaymentQueueSearchFilter = PaymentQueueSearchFilter;
var IPaginatedPaymentQueues = /** @class */ (function () {
    function IPaginatedPaymentQueues() {
    }
    return IPaginatedPaymentQueues;
}());
exports.IPaginatedPaymentQueues = IPaginatedPaymentQueues;
var PaginatedPaymentQueues = /** @class */ (function (_super) {
    __extends(PaginatedPaymentQueues, _super);
    function PaginatedPaymentQueues(json) {
        var _this = _super.call(this, json) || this;
        _this.total = json.total;
        _this.paymentQueues = json.paymentQueues;
        return _this;
    }
    return PaginatedPaymentQueues;
}(CommonModels_1.Pagination));
exports.PaginatedPaymentQueues = PaginatedPaymentQueues;
//# sourceMappingURL=PaymentQueue.js.map